export default {
  layout: {
    main: 'dt.myContests.layout.main',

    header: {
      main: 'dt.myContests.header.main',
      title: 'dt.myContests.header.title',
      chevron: 'dt.myContests.header.chevron',
      breadcrumps: 'dt.myContests.header.breadcrumps',
      subTitle: 'dt.myContests.header.subTitle',
      poster: 'dt.myContests.header.poster',
      tabs: {
        main: 'dt.myContests.header.tabs.main',
        list: 'dt.myContests.header.tabs.list',
        active: 'dt.myContests.header.tabs.active',
      },
      action: 'dt.myContests.header.action',
    },

    content: {
      main: 'dt.myContests.content.main',
      pills: 'dt.myContests.content.pills',
      grid: {
        main: 'dt.myContests.content.grid.main',
      },
    },
    skeleton: 'dt.myContests.skeleton',
  },
};
